import template from './profile-link.html';
import './profile-link.global.css';

class ProfileLinkController {
  constructor() {
    this.linkText = 'View Profile';
  }

  get analyticsEvent() {
    return `Clicked ${this.name} Profile Link`;
  }
}

export const ProfileLinkComponent = {
  template,
  controller: ProfileLinkController,
  bindings: {
    // If `href` is defined it will take precedence over `uiSref`
    // causing the link to open in a new tab.
    href: '@',
    uiSref: '@',
    name: '@',
  },
};
